import * as React from "react";
import { cn } from "../../lib/utils";

/**
 * Text field styled for the design system.
 * @param {Object} props
 * @param {string} [props.className]
 * @param {string} [props.type]
 * @returns {JSX.Element}
 */
const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full min-w-0 rounded-md border border-ui-border bg-ui-card px-3 py-1 text-base text-ui-foreground shadow-sm transition-colors md:text-sm",
        "file:border-0 file:bg-transparent file:text-sm file:font-medium",
        "placeholder:text-ui-muted-foreground",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ui-ring focus-visible:ring-offset-2 focus-visible:ring-offset-ui-background",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = "Input";

export { Input };
